import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'
import { Box, Text, getPaletteColor } from 'pcln-design-system'
import { ActionCard } from '@pcln/cards'
import useRecentSearchCard from '@/hooks/useRecentSearchCard'
import { Carousel } from 'pcln-carousel'
import analytics from '@/shared-utils/analytics'
import { ANALYTICS_CATEGORY_HOME } from '@/constants/analytics'
import useBootstrapData from '@/hooks/useBootstrapData'
import getProductInfo from './utils'

const StyledWrapper = styled(Box)`
  padding: 16px 0;
  box-shadow: 16px 0px 0px 0px ${getPaletteColor('priceSecondary.light')},
    -16px 0px 0px 0px ${getPaletteColor('priceSecondary.light')};

  ${themeGet('mediaQueries.md')} {
    box-shadow: 16px 0px 0px 0px ${getPaletteColor('priceSecondary.light')};
    padding: 16px 0 16px 16px;
  }
`

export default function RecentSearchCardsExperiment() {
  const [isBrowser, setIsBrowser] = useState(false)
  useEffect(() => {
    setIsBrowser(true)
  }, [setIsBrowser])
  const {
    webstats: { clientGUID },
    customer: { firstName = '' },
    appName,
    appVersion
  } = useBootstrapData()
  const data = useRecentSearchCard(clientGUID, { appName, appVersion })
  const firstFiveCards = data.length > 5 ? data.slice(0, 5) : data
  return firstFiveCards.length ? (
    <StyledWrapper
      borderRadius="2xl"
      flexWrap={['wrap', null, 'unset']}
      bg="priceSecondary.light"
      mb={30}
    >
      <Box ml={[0, null, null, -1]}>
        <Text
          width="100%"
          mb={2}
          ml={[1, null, null, 0]}
          textStyle={['heading4', 'heading2']}
          color="text.heading"
        >
          {firstName ? `${firstName}, pick` : 'Pick'} up where you left off
        </Text>
        {isBrowser && (
          <Carousel
            arrowsPositions="top"
            arrowsPosition="side"
            currentSlide={0}
            displayArrowsMobile={false}
            slideSpacing={1}
            onSlideChange={() => {
              // do  nothing
            }}
            visibleSlides={[2.5, 2.5, 3.5]}
            mobileVisibleSlides={[1.2, 2.5]}
          >
            {firstFiveCards.map((item, index) => {
              const { heading, icon, title, subtitle, url } =
                getProductInfo(item)
              return (
                <ActionCard
                  key={heading || index}
                  titleWidth={['224px', null, null, '250px']}
                  icon={icon}
                  title={title}
                  subTitle={subtitle}
                  heading={heading}
                  onClick={() => {
                    analytics.fireEvent({
                      category: ANALYTICS_CATEGORY_HOME,
                      action: 'Personalized Shortcut',
                      label: 'Recent Search Shortcut'
                    })
                    window.open(url)
                  }}
                  handleSubmitCTA={() => {
                    analytics.fireEvent({
                      category: ANALYTICS_CATEGORY_HOME,
                      action: 'Personalized Shortcut',
                      label: 'Recent Search Shortcut'
                    })
                    window.open(url)
                  }}
                  className="full-width"
                />
              )
            })}
          </Carousel>
        )}
      </Box>
    </StyledWrapper>
  ) : null
}
